import ResetStyle from './reset'
import W1Style from './styles'

const Styles: React.FC<{}> = () => (
  <>
    <ResetStyle />
    <W1Style />
  </>
)

export default Styles
